import { useFormikContext } from 'formik';
import React, { useEffect } from 'react';
import { useDebounce } from 'use-debounce';
import { AutoComplete, VisuallyHiddenInput, withFormikSupport } from '@fourthwall/components';
import { HS_CODE_LENGTH } from '../../consts';
import { useHSCodesQuery } from '../queries/useHSCodesQuery';
import * as S from './styled';
const SEARCH_CHARS_MIN_LIMIT = 3;
const SEARCH_CHARS_MAX_LIMIT = 50;
const formatHSCode = (code) => {
    if (!code)
        return '';
    if (code.length <= 4)
        return code;
    if (/^\d+$/.test(code)) {
        return `${code.slice(0, 4)}.${code.slice(4)}`;
    }
    return code;
};
const removeFormat = (code) => code.replace('.', '');
const HSCodeSelectComponent = ({ name, label, suggestion, value, error, onChange, }) => {
    const { values, dirty, setFieldValue } = useFormikContext();
    const [debouncedValue] = useDebounce(value || '', 500);
    const isSearchValid = debouncedValue?.length >= SEARCH_CHARS_MIN_LIMIT &&
        debouncedValue.length < SEARCH_CHARS_MAX_LIMIT;
    const { HSCodesQuery } = useHSCodesQuery([
        {
            categoryId: !isSearchValid && !!values.categoryId ? values.categoryId : undefined,
            search: isSearchValid ? debouncedValue : undefined,
        },
    ]);
    useEffect(() => {
        if (!dirty || !value || value.length !== HS_CODE_LENGTH)
            return;
        const hasHsCodes = HSCodesQuery.isFetching || (HSCodesQuery.data && HSCodesQuery.data.length > 0);
        setFieldValue('customsInformation.hasHsCodes', hasHsCodes);
    }, [value, HSCodesQuery.data, HSCodesQuery.isFetching, setFieldValue, dirty]);
    const handleSelect = (option) => {
        if (option?.id) {
            onChange(option.id);
        }
    };
    const options = HSCodesQuery.data?.map((item) => ({
        id: item.code,
        content: (React.createElement(S.Option, null,
            React.createElement(S.OptionCode, null, formatHSCode(item.code)),
            " - ",
            item.description)),
    })) || [];
    const handleChange = (e) => {
        const newValue = removeFormat(e.target.value);
        onChange(newValue);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(VisuallyHiddenInput, { name: name }),
        React.createElement(AutoComplete, { label: label, options: options, optionsLabel: !debouncedValue ? 'Suggestions' : undefined, emptyState: React.createElement(S.EmptyState, null, "No results found"), suggestion: suggestion, value: formatHSCode(value), error: error, withArrow: true, maxLength: SEARCH_CHARS_MAX_LIMIT, isLoading: HSCodesQuery.isFetching, onChange: handleChange, onSelect: handleSelect })));
};
export const HSCodeSelect = withFormikSupport(HSCodeSelectComponent);
